import { Listing, ProductType } from '@/components/CrossSell/types'
import { GA4ProductMap, GA4ProductMapShort } from './types'

export type BuildGA4ObjectForPostBookingXSellInput = {
  event: 'select_promotion_bundle' | 'view_promotion_bundle'
  product: ProductType
  xSellProduct: ProductType
  offerId: string
  destination: string
  listings?: Listing[]
}

const buildGA4ObjectForPostBookingXSell = ({
  event,
  product,
  xSellProduct,
  offerId,
  destination,
  listings
}: BuildGA4ObjectForPostBookingXSellInput) => ({
  event,
  attributes: {
    type: 'xsell',
    page_name: 'homepage',
    product_name: GA4ProductMap[product],
    promotion_id: `xs${GA4ProductMapShort[xSellProduct]}`,
    promotion_name: GA4ProductMap[xSellProduct],
    creative_name: `${GA4ProductMap[xSellProduct]}_${destination}_banner`,
    creative_slot: listings
      ? 'featured_items'
      : `postbooking ${GA4ProductMap[xSellProduct]} xsell`,
    location_id: 'hero_banner',
    ecommerce: {
      transaction_id: offerId,
      ...(listings
        ? {
            items: listings.map((listing, index) => {
              return {
                index,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                id: listing.hotelId ?? listing.id,
                promotion_id: `xs${GA4ProductMapShort[product]}${GA4ProductMapShort[xSellProduct]}`,
                promotion_name: `xs_${GA4ProductMap[product]}_${GA4ProductMap[xSellProduct]}`
              }
            })
          }
        : {})
    }
  }
})

export default buildGA4ObjectForPostBookingXSell
